// 日语
export const Japanese = {
  language_code: "ja",
  get_btn: "今すぐ受け取る",
  unregistered_tip: "未登録のユーザーは直接アカウントを作成します。",
  phone_number: "電話番号",
  ver_code: "認証コード",
  get_ver_code: "コードを取得",
  retrieve_ver_code: "再取得 ({SECONDS})",
  age_tip: "私は成年で完全な民事能力を持ち、",
  and: " と ",
  age_tip_1: " に同意します",
  PRIVICY_POLICY: "《プライバシーポリシー》",
  MEMBER_AGGREMENT: "《会員規約》",
  agree_push:
    "登録した電話番号またはメールアドレスで海底撈からのお知らせを受け取ることに同意します。",
  CN: "中国",
  US: "アメリカ",
  CA: "カナダ",
  GB: "イギリス",
  MY: "マレーシア",
  AU: "オーストラリア",
  ID: "インドネシア",
  SG: "シンガポール",
  TH: "タイ",
  JP: "日本",
  KR: "韓国",
  VN: "ベトナム",
  HK: "香港",
  MO: "マカオ",
  HKM: "カンボジア",
  TW: "台湾",
  PH: "フィリピン",
  UAE: "アラブ首長国連邦",
  suc_send: "送信完了",
  suc_get: "受け取り成功",
  fail_ver_code: "認証コードが間違っています",
  time_end: "イベントは終了しました",
  not_get_repeat: "繰り返し受け取れません！",
  not_get_eligible: "条件に合わないため、受け取れません。",
  not_get_late: "少し遅かったため、イベントは終了しました。",
  get_coupon: "クーポンを取得",
  phone_err: "電話番号が無効です。正しい番号を入力してください。",
  page_title: "海底撈専用クーポンを取得",
  send_code_error: "認証コードの送信エラー",
  network_error: "現在ネットワークが不安定です。後ほど再試行してください",
  member_status_abnormal: "メンバーアカウントに問題があり、受け取れません",
  send_frequently:
    "送信された認証コードが多すぎます。最後に受け取ったコードを入力するか、後で再試行してください。",
  activity_boom: "受け取り人数が多すぎます。しばらくしてからお試しください。",
  email: "メール",
  email_error_tip:
    "メールアドレスが無効です。正しいアドレスを入力してください。",
  suc_get_dialog_text:
    "すぐに海底撈会員アプリを開いて、受け取ったクーポンを確認しましょう！",
  btn_sure: "はい",
  btn_cancel: "キャンセル",
  suc_dialog_text:
    "海底撈アプリを開くか、LINEで会員を連携して、受け取ったクーポンを確認しましょう!",
  btn_return: "戻る",
  btn_download: "ダウンロード",
};
